<div class="breadcrumb m-0 p-0 bg-white"
     *ngIf="breadcrumbs">
  <li class="breadcrumb-item pointer btn-link"
      ngbTooltip="Precedente"
      container="body"
      (click)="onSelectedObject(breadcrumbs[0])"><a>{{breadcrumbs[0].alias}}</a></li>
  <li class="breadcrumb-item active"
      ngbTooltip="Attuale"
      aria-current="object">{{breadcrumbs[1].alias}}</li>
</div>